import { render, staticRenderFns } from "./project-edit.vue?vue&type=template&id=3d36705c&"
import script from "./project-edit.vue?vue&type=script&lang=js&"
export * from "./project-edit.vue?vue&type=script&lang=js&"
import style0 from "./project-edit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports